import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/css/reset.css'
import '@/assets/js/remnew.js'
import '@/assets/css/base.css' /*引入公共样式*/
import '@/assets/css/style.css'
import 'vant/lib/button/style/less';

import Vant from 'vant'
import { Lazyload } from 'vant';

import {
  getURLParameter
} from './common/common.js'
import {
  //syncToken,
  goLogin,
  //getToken,
  //setToken,
  getUserInfo,
  getUser,
  //getBindVehicleState
} from './common/loginwx.js' //getToken,goLogin,syncToken,setToken
Vue.use(Vant);
Vue.use(Lazyload);
import 'vant/lib/index.css'
import './plugins/element.js'

import global_ from './components/tool/global'
Vue.prototype.GLOBAL = global_


Vue.config.productionTip = false
document.title = '苏豪仓储';

router.beforeEach((to, from, next) => {
  var wx_code = getURLParameter('code');
  //var wx_state = getURLParameter('state');

  //页面设置account_id后 重置当前访问的account_id
  var openid = store.state.wx_info.openid;
  if (openid) {
    store.commit('set_openid', openid)
  }


  if (openid) {
    if (to.meta.title) {
      document.title = to.meta.title
    }
    getUser(openid, function() {
      if (store.state.wx_info.openid) {
        next();
      }
    });
    //next();
  } else {
    if (wx_code) {
      getUserInfo(wx_code, function() {
        if (store.state.wx_info.openid) {
          next();
        } else {
          document.title = '正在登录...';
          store.commit('set_login_go', to.fullPath); //页面将要跳转的地址
          goLogin(to.fullPath);
        }
      })
    } else {
      //如果token、code都不存在,页面第一次进入的时候
      document.title = '正在登录...';
      store.commit('set_login_go', to.fullPath); //页面将要跳转的地址
      goLogin(to.fullPath); //通过account_id获取appid,然后跳转到auth_url，获取code，然后会再重新执行router.beforeEach
    }
  }


});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
